/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Diff_FeedInputs */

const cs_ebr_diff_feed = /** @type {(inputs: Ebr_Diff_FeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feed eBrána`)
};

const en_ebr_diff_feed = /** @type {(inputs: Ebr_Diff_FeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`eBrána feed`)
};

/**
* | output |
* | --- |
* | "eBrána feed" |
*
* @param {Ebr_Diff_FeedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_diff_feed = /** @type {((inputs?: Ebr_Diff_FeedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Diff_FeedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_diff_feed(inputs)
	return cs_ebr_diff_feed(inputs)
});